export default "__VITE_ASSET__Dd0iTOJq__"